/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { EnumPropertyOption } from "./EnumPropertyOption";
import { EnumPropertySortBy } from "./EnumPropertySortBy";
export const EnumPropertyConfig = core.serialization.object({
    allowCustom: core.serialization.boolean().optional(),
    options: core.serialization.list(EnumPropertyOption),
    sortBy: EnumPropertySortBy.optional(),
});
